export const syndicateMembers: { name: string, image: string, modName?: string, signatureMod: string }[] = [];
